/**
 * ═══════════════════════════════════════════════════════════════════════════
 * **LE SEUL FICHIER DE `web/src` QUI VA CHERCHER DES OCTETS À UNE ADRESSE —
 * D-130, ARBITRAGE 4.**
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * **Quatrième port de ce dépôt, et il a exactement la forme des trois autres** :
 * `moteur.tsx` pour Excalidraw (D-012), `canal.ts` pour socket.io (D-002), `visio.ts`
 * pour LiveKit (D-003). Un fichier unique autorisé à connaître **un moyen**, et une sonde
 * qui exige qu'il reste unique — ici `web/e2e/port-du-contenu.spec.ts`.
 *
 * **Le moyen de ce port-ci n'est pas une bibliothèque, c'est la capacité du navigateur à
 * lire des octets à une adresse.** Il débloque deux des sept chemins d'entrée d'image de
 * F-24, qui butaient tous deux sur la même chose : le fichier pris dans son espace de
 * fichiers (Q356) et l'adresse web collée (Q360).
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **CE N'EST PAS UN AFFAIBLISSEMENT DE `DOCTRINE.md` §11, ET C'EST CE QUI REND CE
 * FICHIER TENABLE.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * L'interdit de §11 vise « **contourner la couche contrat** en écrivant un appel réseau
 * nu », et il ajoute pourquoi : « si le client généré ne couvre pas un besoin, **on
 * corrige le contrat côté back**. » **La couche contrat est l'API du produit.** Lire les
 * octets d'une image au domaine du contenu, ou à une adresse qu'une personne a collée,
 * **ne contourne aucun contrat** : il n'y en a pas, et il n'y a rien à corriger côté
 * back. C'est la même frontière que `ImageDeContenu`, qui charge déjà une adresse du
 * domaine du contenu par une balise `<img>`.
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **LA BORNE QUI NE SE NÉGOCIE PAS : C'EST LE NAVIGATEUR QUI VA CHERCHER, JAMAIS LE
 * PRODUIT.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * F-24 critère 5 : « **LE SYSTÈME DOIT ne jamais émettre d'appel sortant vers une adresse
 * fournie par une personne.** » Q360 le dit du côté du geste : « **le navigateur de la
 * personne va chercher l'image à l'adresse collée, jamais le produit** », et son motif
 * n'est pas le confort — « faire aller le produit chercher une adresse fournie par un
 * élève créerait une surface d'appel sortant que **rien d'autre dans le produit n'a** ».
 *
 * **C'est pour cela que ce port vit dans `web/` et nulle part ailleurs.** Aucune ligne
 * d'`api/` ne gagne le droit de suivre une adresse, et la sonde de ce port balaye `api/`
 * pour le tenir. Ce que le serveur reçoit reste **des octets**, par la route de dépôt
 * déjà écrite, exactement comme par les quatre autres chemins.
 *
 * **Le coût est écrit dans le corpus et il n'est pas réparable ici** (Q360) : « certaines
 * adresses refuseront de se laisser lire par un navigateur là où un serveur aurait
 * réussi ». Une page qui ne rend pas `Access-Control-Allow-Origin` est illisible depuis
 * cet onglet, et **c'est le régime voulu**. Le corpus dit aussi que le cas réel est servi
 * ailleurs : « coller une image copiée depuis une page web passe par le **collage** ».
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **TROIS RÉGLAGES DE L'APPEL PORTENT CHACUN UNE RÈGLE, ET LA SONDE LES TIENT.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * - **`credentials: 'omit'`.** L'adresse est fournie par une personne : y attacher les
 *   justificatifs de qui la colle enverrait la session du produit à un tiers. Le chemin
 *   du Drive n'en a pas besoin non plus — D-005 sert le contenu « **depuis un domaine
 *   séparé sans cookies, par URLs présignées de courte durée** », et une URL présignée
 *   porte déjà son droit.
 * - **`referrerPolicy: 'no-referrer'`.** Sans elle, le navigateur annonce l'adresse de la
 *   page — donc **l'identifiant du cours** — au serveur d'en face. `ImageDeContenu` pose
 *   déjà exactement la même ligne, pour exactement la même raison.
 * - **Un délai d'abandon.** Q361 : « quand l'adresse **ne répond pas**, il abandonne et
 *   le dit ». Une adresse qui accepte la connexion et ne répond jamais ne se distingue
 *   d'une adresse morte que par le temps, donc il en faut un. **Ce n'est pas une règle du
 *   cahier des charges, c'est ce qu'« abandonne » demande pour exister.**
 *
 * ───────────────────────────────────────────────────────────────────────────
 * **CE QUE CE PORT NE FAIT PAS.**
 * ───────────────────────────────────────────────────────────────────────────
 *
 * **Il ne pose rien sur le tableau et n'appelle aucune route.** Il rend un `File`, et
 * `images.ts` le fait entrer par le chemin déjà écrit — proportions lues chez la
 * personne, placement demandé au moteur, dépôt par la route. C'est ce qui fait qu'un
 * fichier pris dans son espace est **copié, jamais lié** (Q356, Q455) : le tableau reçoit
 * des octets, jamais une référence au Drive, et « un lien ferait dépendre un tableau figé
 * d'un fichier que son propriétaire peut supprimer ».
 *
 * **Il ne juge pas ce que les octets contiennent.** « Le type réel est contrôlé par la
 * **signature binaire**, jamais par l'extension annoncée » (Q357, D-005), et ce contrôle
 * appartient au serveur. Ce qui se vérifie côté écran est seulement que l'image
 * **s'affiche** — `images.ts` le fait déjà en lisant ses proportions, et c'est cette
 * lecture qui sert « ou ne rend pas une image » (Q361).
 *
 * **UN PRÉREQUIS D'INFRASTRUCTURE PÈSE SUR LE CHEMIN DU DRIVE, ET IL N'EST PAS FAIT.**
 * C'est le même que D-122 et F-25 nomment déjà pour le document : lire les octets d'un
 * fichier d'une autre origine exige que **le contenant de stockage réponde
 * `Access-Control-Allow-Origin`**. Le contenant local le fait ; ceux de la recette et de
 * la production ne sont pas réglés. **Sans lui, prendre un fichier de son espace échoue
 * en recette**, et la personne lit le refus de Q361 sur une cause qui n'est pas la
 * sienne. Écrit ici plutôt que découvert.
 */

/**
 * **Ce qu'une lecture peut coûter au plus avant qu'on abandonne.**
 *
 * Valeur de fabrication, comme la cible de réduction d'une image l'est en Q359 — « la
 * valeur exacte est de la fabrication et non du cahier des charges ».
 */
const ATTENTE_MAXIMALE_MS = 15_000;

/** Le nom donné quand l'adresse n'en porte aucun de lisible. */
const NOM_DE_REPLI = 'image';

/**
 * **Le refus, en une phrase, et il dit le geste qui le lève.**
 *
 * `CDC-0` §8 : « le produit explique ses refus, **partout** ». Ici la cause la plus
 * fréquente n'est pas une adresse morte, c'est une page qui refuse d'être lue par un
 * navigateur — coût écrit de Q360. Une phrase qui dirait seulement « échec » laisserait
 * la personne recommencer le même geste.
 */
const PHRASE_DU_REFUS =
  'Rien n’a pu être lu à cette adresse, et rien n’a été posé sur le tableau. ' +
  'Beaucoup de pages refusent de se laisser lire par un autre site : enregistrez ' +
  'l’image chez vous, puis déposez le fichier.';

/**
 * **Seules `http` et `https` sont des adresses web.**
 *
 * `file:` désignerait le disque de la personne, `data:` et `blob:` ne sont pas des
 * adresses mais des octets déjà en main — et une adresse collée qui en serait une
 * arriverait ici sans que personne l'ait voulu.
 */
const PROTOCOLES_LUS = ['http:', 'https:'];

/**
 * **Le nom de fichier que porte une adresse, ou un nom de repli.**
 *
 * Le nom ne décide rien : « le type réel est contrôlé par la signature binaire, jamais
 * par l'extension annoncée » (Q357). Il sert à ce que la personne reconnaisse ce qu'elle
 * vient de poser.
 */
function nomDeFichierDeLAdresse(adresse: string): string {
  try {
    const dernier = new URL(adresse).pathname
      .split('/')
      .filter((morceau) => morceau.length > 0)
      .at(-1);
    if (dernier === undefined) return NOM_DE_REPLI;
    return decodeURIComponent(dernier) || NOM_DE_REPLI;
  } catch {
    return NOM_DE_REPLI;
  }
}

/**
 * **Les octets qui vivent à cette adresse, lus par le navigateur de la personne.**
 *
 * Rend un `File`, comme si la personne l'avait choisi elle-même : c'est ce qui fait que
 * les deux chemins débloqués entrent par le chemin déjà spécifié — « fichier déposé,
 * réduit à l'entrée, type contrôlé par signature binaire — donc **aucune règle
 * nouvelle** » (Q360).
 *
 * **Lève quand rien ne se lit**, et l'appelant dit ce refus à qui a agi sans rien poser
 * (Q361). Le message est déjà en français : `lireLErreur` rend le `message` d'une erreur
 * ordinaire, et `images.ts` le montre tel quel.
 */
export async function fichierDepuisUneAdresse(
  adresse: string,
  nom?: string,
): Promise<File> {
  let cible: URL;
  try {
    cible = new URL(adresse);
  } catch {
    throw new Error(PHRASE_DU_REFUS);
  }
  if (!PROTOCOLES_LUS.includes(cible.protocol)) throw new Error(PHRASE_DU_REFUS);

  let octets: Blob;
  try {
    const reponse = await fetch(cible.toString(), {
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      redirect: 'follow',
      signal: AbortSignal.timeout(ATTENTE_MAXIMALE_MS),
    });
    if (!reponse.ok) throw new Error(PHRASE_DU_REFUS);
    octets = await reponse.blob();
  } catch {
    // **Tous les échecs se disent de la même façon, et c'est voulu.** Une adresse morte,
    // un refus de lecture par un autre site et un délai dépassé ne demandent pas des
    // gestes différents à la personne ; distinguer les trois lui ferait lire un
    // diagnostic réseau au lieu de ce qu'elle peut faire.
    throw new Error(PHRASE_DU_REFUS);
  }

  if (octets.size === 0) throw new Error(PHRASE_DU_REFUS);

  return new File([octets], nom ?? nomDeFichierDeLAdresse(adresse), {
    type: octets.type,
  });
}
